import { Region } from '../../../integrated-client/models'

export interface IRegionEditorData {
  regionData?: Region
  validation?: any
}
export class RegionEditorData implements IRegionEditorData {

  regionData?: Region
  validation?: any
}